import { initColorPickerFields } from "../components/colorPickerField";

/**
 * Work 상세 hero 배경 — `_form-fields.php` 의 `[data-color-picker][data-color-mode="form"]`.
 * 선택한 값(hex 또는 그라데이션 CSS 문자열)은 숨은 input `name="hero_visual_bg_color"` 에만 동기화되고,
 * 실제 커밋은 폼 맨 아래 저장 버튼이 한다(autosave 아님).
 */
export function initHeroVisualColorPicker(scope: HTMLElement): void {
    initColorPickerFields(scope);
}
